import { HttpParams } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NbDialogService } from '@nebular/theme';
import { DatatableComponent, SelectionType } from '@swimlane/ngx-datatable';
import { NotificationsService } from 'angular2-notifications';
import { IMyDpOptions } from 'mydatepicker';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatatableService } from '../../../../shared/services/datatable.service';
import { DateUtilService } from '../../../../shared/services/date-util.service';
import { SpringDatatablePagination } from '../../../../shared/services/spring-integration/pagination/spring-datatable-pagination';
import { SpringDatatablePaginationService } from '../../../../shared/services/spring-integration/pagination/spring-datatable-pagination.service';
import { ModalConfirmarEstoqueComponent } from '../modal-confirmar-estoque/modal-confirmar-estoque.component';
import { ImportarCartaoService } from './importar-cartao.service';
import { ExportExcelService } from '../../../../shared/services/export-excel.service';

@Component({
  selector: "ngx-importar-cartao",
  templateUrl: "./importar-cartao.component.html",
  styleUrls: ["./importar-cartao.component.scss"],
})
export class ImportarCartaoComponent implements OnInit {
  @ViewChild("myTable", null)
  private myTable: DatatableComponent;
  formImportaCartao: FormGroup;
  public rowData: any = [];
  public tableLimit = 10;
  public datatablePagination: SpringDatatablePagination =
    new SpringDatatablePagination();
  public listPostagem: any = [];
  public totalQtde: number = 0;
  public exportTotal = null;
  public addRow = false;
  public erroLog: number = 0;
  formattedText: string;
  formatCodPostagem: string;
  checkboxArray = [];
  checkeds = [];
  check;
  customLogin;
  square: boolean = false;
  selected = [];
  pagedRows: any[] = [];
  SelectionType = SelectionType;
  currentPage = 0;
  pageSize = this.tableLimit;
  rows: any[] = [];
  columnsTable = [
    { columnName: "cartao", newColumnName: "Cartão" },
    { columnName: "codigoPostagem", newColumnName: "Código Postagem" },
    { columnName: "dataEmissao", newColumnName: "Data Emissão" },
    { columnName: "logo", newColumnName: "Logo" },
    { columnName: "status", newColumnName: "Status" },

  ];
  public postagemArray = [];
  public uniquePostagemArray = [];

  myDatePickerOptions: IMyDpOptions = {
    dateFormat: "dd/mm/yyyy",
    showClearDateBtn: false,
    openSelectorOnInputClick: true,
    showTodayBtn: false,
    allowSelectionOnlyInCurrentMonth: false,
    dayLabels: {
      su: "Dom",
      mo: "Seg",
      tu: "Ter",
      we: "Qua",
      th: "Qui",
      fr: "Sex",
      sa: "Sab",
    },
    monthLabels: {
      1: "Jan",
      2: "Fev",
      3: "Mar",
      4: "Abr",
      5: "Mai",
      6: "Jun",
      7: "Jul",
      8: "Ago",
      9: "Set",
      10: "Out",
      11: "Nov",
      12: "Dez",
    },
    firstDayOfWeek: "su",
  };

  constructor(
    private formBuilder: FormBuilder,
    private paginationService: SpringDatatablePaginationService,
    private service: ImportarCartaoService,
    private router: Router,
    private notificationService: NotificationsService,
    private spinnerService: NgxSpinnerService,
    private datatableService: DatatableService,
    private dialogService: NbDialogService,
    private dateUtilService: DateUtilService,
    private exportExcelService: ExportExcelService
  ) {
    this.paginationService.setDatatablePagination(this.datatablePagination);
  }

  ngOnInit() {
    let resCustom = localStorage.getItem("bway-customLogin");
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.formImportaCartao = this.formBuilder.group({
      numCartao: [null],
      biparCartao: [null],
      logo: [null],
      dataInicio: [null],
      dataFim: [null],
    });

    this.datatableService.subscribeTable(this.myTable);
  }

  getRouter(): Router {
    return this.router;
  }

  codPostagem(data) {
    const cleanedItem = data.biparCartao.replace("$", "");

    // Verifica se o item já está na lista antes de adicionar
    if (!this.listPostagem.includes(cleanedItem)) {
      this.listPostagem.push(cleanedItem);
    } else {
      this.notificationService.warn("Número já na lista");
    }

    this.formattedText = this.formatJsonArray(this.listPostagem, 5);
    this.formImportaCartao.controls["biparCartao"].setValue(null);
  }

  formatJsonArray(arr: string[], count: number): string {
    return arr
      .reduce((acc, val, index) => {
        if (index > 0 && index % count === 0) {
          acc += "\n";
        }
        acc += val + ", ";
        return acc;
      }, "")
      .slice(0, -2); // Remove a última vírgula e espaço
  }

  onSelect({ selected }) {
    const selectedIds = new Set(selected.map((row) => row.id));

    this.selected = this.selected.filter((row) => selectedIds.has(row.id));

    selected.forEach((row) => {
      if (!this.selected.some((r) => r.id === row.id)) {
        this.selected.push(row);
      }
    });

    console.log("Selected Rows after update:", this.selected);
  }

  onActivate(event) {
    console.log("Activate Event", event);
  }

  limparLista() {
    this.formattedText = null;
    this.listPostagem = [];
    this.formImportaCartao.controls["biparCartao"].setValue(null);
    this.formatCodPostagem = "";
  }

  limparForm() {
    this.formImportaCartao.controls["biparCartao"].setValue(null);
    this.formImportaCartao.controls["numCartao"].setValue(null);
    this.formImportaCartao.controls["dataInicio"].setValue(null);
    this.formImportaCartao.controls["dataFim"].setValue(null);
    this.formImportaCartao.controls["logo"].setValue(null);
    this.limparLista();
  }

  limpar(){
    this.rows = [];
  }

  buscar(data?: any, page?: string, size?: string) {
    let params = new HttpParams();
    params = params.append("allElements", "true");
    params = params.append("size", String("99999999"));

    if (this.validaCampo(data)) {
      params = params.append("logo", data.logo);
      let dataInicio = this.dateUtilService.datepickerTransformDate(
        data.dataInicio,
        "YYYY-MM-DD"
      );
      params = params.append("dataInicio", dataInicio);
      let dataFim = this.dateUtilService.datepickerTransformDate(
        data.dataFim,
        "YYYY-MM-DD"
      );
      params = params.append("dataFim", dataFim);


      if (data.numCartao != null) {
        params = params.append("numCartao", data.numCartao);
      }

      this.spinnerService.show();
      this.service.buscarCard(
        params,
        (response) => {
          this.erroLog = response.content.length;
          this.paginationService.setInfo(response);
          this.rows = response.content;
          this.spinnerService.hide();

          if (this.erroLog == 0) {
            this.notificationService.warn("Não há dados!");
          }
        },
        (erro) => {
          this.spinnerService.hide();
          this.notificationService.warn(erro.message);
        }
      );
    }
  }

  validaCampo(data) {
    console.log(data)
    if (!data.dataInicio || !data.dataFim) {
      this.notificationService.warn(
        "Os campos data início e data fim são obrigatórios."
      );
      return false;
    }
    const dataInicio = new Date(data.dataInicio.epoc);
    const dataFim = new Date(data.dataFim.epoc);
    if (dataInicio > dataFim) {
      this.notificationService.warn(
        "A data inicial não pode ser maior que a data final."
      );
      return false;
    }

    if (!data.logo || !data.logo.trim()) {
      this.notificationService.warn("O campo logo é obrigatório.");
      return false;
    }

    return true;
  }

  salvarCadastro() {
    const selectedPostagemArray = this.selected.map(
      (obj) => obj.codigoPostagem
    );
    const listPostagemArray = this.listPostagem.map((postagem) => postagem);

   this.uniquePostagemArray = Array.from(
    new Set([...selectedPostagemArray, ...listPostagemArray])
  );
    if (!this.uniquePostagemArray.length) {
      this.notificationService.warn(
        "Para prosseguir é necessário selecionar algum cartão."
      );
    } else {
      this.dialogService
        .open(ModalConfirmarEstoqueComponent, {
          context: {
            qtdeElements: this.uniquePostagemArray.length,
          },
        })
        .onClose.subscribe((validacao) => this.salveCard(validacao));
    }

    this.limparForm();
    this.limparLista();
  }

  salveCard(value: boolean) {
    console.log(this.uniquePostagemArray);
    if (value) {
      let register = {
        codigoPostagem: this.uniquePostagemArray,
        status: "DISPONIVEL",
      };

      this.spinnerService.show();

      this.service.salveCard(
        register,
        (res) => {
          console.log(res.notFoundCodes);
          this.formatCodPostagem = res.cartoesNaoEncontrados.join(", ");
          this.spinnerService.hide();
          this.notificationService.success(res.mensagem);
          this.checkboxArray = [];
          this.check = false;
          this.checkeds = [];
          this.uniquePostagemArray = [];
          this.postagemArray = [];
          this.rowData = [];
          this.currentPage = 0;
          this.selected = [];
          this.rows = [];
          const checkboxes: any = document.getElementsByName("notifcheck");
          checkboxes.forEach((element) => {
            element.checked = this.check;
          });

          this.limparForm();
        },
        (error) => {
          this.spinnerService.hide();
          this.notificationService.error(error.message);
        }
      );
    }
  }

  previousPage() {
    this.router.navigate(["/iot-dashboard"]);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

  updatePagedRows() {
    const start = this.currentPage * this.pageSize;
    const end = start + this.pageSize;
    this.pagedRows = this.rows.slice(start, end);
  }

  goToPreviousPage() {
    if (this.currentPage > 0) {
      this.currentPage--;
      this.updatePagedRows();
    }
  }

  goToNextPage() {
    if (this.currentPage < this.getTotalPages() - 1) {
      this.currentPage++;
      this.updatePagedRows();
    }
  }

  isFirstPage(): boolean {
    return this.currentPage === 0;
  }

  isLastPage(): boolean {
    return this.currentPage === this.getTotalPages() - 1;
  }

  getTotalPages(): number {
    return Math.ceil(this.rows.length / this.pageSize);
  }

  _handlePageChange(event: any) {
    this.currentPage = event.offset;
    this.updatePagedRows();
  }

  exportarExcel(data?: any, _page?: any) {
    let params = new HttpParams();
    

    params = params.append('allElements', 'true');

    params = params.append('size', String(999999999));

    if (data.logo != null) {
      params = params.append("logo", data.logo);
    }

    if (data.dataInicio != null) {
      let dataInicio = this.dateUtilService.datepickerTransformDate(data.dataInicio,"YYYY-MM-DD");
      params = params.append("dataInicio", dataInicio);
    }

    if (data.dataFim != null) {
      let dataFim = this.dateUtilService.datepickerTransformDate(data.dataFim, "YYYY-MM-DD");
      params = params.append("dataFim", dataFim);
    }

    if (data.numCartao != null) {
      params = params.append("numCartao", data.numCartao);
    }

    let exportDataRows = [];
    this.service.buscarCard(
      params,
      (response) => {

        exportDataRows = response.content;
        if (exportDataRows.length == 0) {
          this.notificationService.warn("Não há dados para exportar!");
        } else {
          this.exportExcelService.exportXlsx(
            exportDataRows,
            this.columnsTable,
            "importar_cartao_estoque"
          );
        }

        if (this.erroLog == 0) {
          this.notificationService.warn("Não há dados!");
        }
      },
      (erro) => {
        this.spinnerService.hide();
        this.notificationService.warn(erro.message);
      }
    );
  }
}
